const UserService = {
  url: `${process.env.VUE_APP_API_URL}`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },

  login: async (user) => {
    try {
      const response = await fetch(`${UserService.url}login`, {
        method: "POST",
        body: JSON.stringify(user),
        headers: UserService.headers,
      });
      return response;
    } catch (e) {
      console.error("Error en login:", e);
      
      // Retornar una respuesta simulada en lugar de false
      return new Response(
        JSON.stringify({
          success: false,
          msg: "Error de conexión. Inténtalo nuevamente.",
        }),
        {
          status: 500,
          headers: { "Content-Type": "application/json" },
        }
      );
    }
  },

  getUser: async (params) => {
    try {
      const headers = UserService.headers;
      headers["Authorization"] = "Bearer " + localStorage.getItem("token");

      const queryString = params
        ? "?" + new URLSearchParams(params).toString()
        : "";

      const response = await fetch(`${UserService.url}user${queryString}`, {
        headers: headers,
      });

      return response;
    } catch (e) {
      console.error("Error en getUser:", e);
      
      // Retornar una respuesta simulada en lugar de false
      return new Response(
        JSON.stringify({
          success: false,
          msg: "Error al obtener datos del usuario.",
        }),
        {
          status: 500,
          headers: { "Content-Type": "application/json" },
        }
      );
    }
  },

  forgotPassword: async (email) => {
    try {
      const headers = UserService.headers;
      headers["Authorization"] = "Bearer " + localStorage.getItem("token");

      const response = await fetch(`${UserService.url}forgot-password`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(email),
      });
      return response;
    } catch (e) {
      console.error("Error en forgotPassword:", e);
      
      // Retornar una respuesta simulada en lugar de false
      return new Response(
        JSON.stringify({
          success: false,
          msg: "Error al enviar email de recuperación.",
        }),
        {
          status: 500,
          headers: { "Content-Type": "application/json" },
        }
      );
    }
  },

  changePassword: async (data) => {
    try {
      const headers = UserService.headers;
      headers["Authorization"] = "Bearer " + localStorage.getItem("token");

      const response = await fetch(`${UserService.url}change-password`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data),
      });
      return response;
    } catch (e) {
      console.error("Error en changePassword:", e);
      
      // Retornar una respuesta simulada en lugar de false
      return new Response(
        JSON.stringify({
          success: false,
          msg: "Error al cambiar la contraseña.",
        }),
        {
          status: 500,
          headers: { "Content-Type": "application/json" },
        }
      );
    }
  },
};

export default UserService;
